import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "icon-cart" }
const _hoisted_2 = {
  key: 0,
  class: "icon-cart__counter",
  style: {"background":"#E42313"}
}

import { computed } from 'vue';
import { useStore } from 'vuex';
import { formatNumber } from '@/helpers';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faShoppingCart } from '@fortawesome/pro-light-svg-icons';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

library.add(faShoppingCart);

const store = useStore();
const cartItemsCount = computed(() => store.getters['cart/countAll']);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-shopping-cart" }),
    (_unref(cartItemsCount) > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(formatNumber)(_unref(cartItemsCount), 0)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})